module.exports = __webpack_public_path__ + "img/rfid-barcode-reader.e7d89b03.jpg";